import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import {Modal, Spin, Table} from 'antd';
import {CloseIcon, MagnifierIcon} from '../../../../../common/icons';
import './FreeSubscriptionPicker.css';
import AirButton from "../../../../../common/components/AirButton";

@inject('translationsStore', 'subscriptionsStore', 'commonStore')
@observer
export default class FreeSubscriptionPicker extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      selectedRow: undefined,
      selectedRowKey: undefined
    };
  }

  buildDataSourceWithKeys = collection => collection.map((item, index) => ({ ...item, key: index }));

  toggleSelectRow = data => {

    this.setState({selectedRow: data, selectedRowKey: data.key})
  };

  onCancel = () => {
    this.setState({
      visible: false,
      selectedRow: undefined,
      selectedRowKey: undefined
    });
  }

  onUseSubscription = () => {
    const {selectedRow} = this.state;
    this.props.onUseFreeSubscription(selectedRow);

    this.onCancel();
  }

  render() {
    const { translationsStore, subscriptionsStore, commonStore } = this.props;
    const { visible, selectedRowKey, selectedRow } = this.state;
    const dataSource = this.buildDataSourceWithKeys(subscriptionsStore.freeSubscriptions);

    const columns = [
      {
        key: 'checkmark',
        dataIndex: 'checkmark',
        render: (text, record) => {
          return (
            <div className={`Checkmark${selectedRowKey === record.key ? ' CheckmarkSelected' : ''}`} onClick={() => this.toggleSelectRow(record)}>
              <span className="checkmark" />
            </div>
          );
        }
      },
      {
        key: 'product',
        dataIndex: 'product',
        title: translationsStore.translate('freeSubscriptionPicker.modal.subscriptionTable.headerLabels.product'),
        render: (text, record) => (!!record.products && !!record.products[0].name ? record.products.map(product => product.name).join(', ') : '-')
      },
      {
        key: 'payment',
        dataIndex: 'payment',
        title: translationsStore.translate('freeSubscriptionPicker.modal.subscriptionTable.headerLabels.payment'),
        render: (text, record) =>
          !!record.subscriptionType && record.subscriptionType.name ? translationsStore.translate(`subscriptionManager.types.${record.subscriptionType.name}`) : '-'
      },
      {
        key: 'end_date',
        dataIndex: 'end_date',
        className: 'ColumnCentered',
        title: translationsStore.translate('freeSubscriptionPicker.modal.subscriptionTable.headerLabels.endDate'),
        render: (text, record) => new Date(record.end_date).toLocaleDateString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit' })
      }
    ];

    const disableButton = !selectedRow || selectedRowKey === undefined;
    return (
      <Fragment>
        <div onClick={() => this.setState({visible : true})} className={'FreeSubscriptionPickerOpenButton'}>
          <MagnifierIcon className={'MagnifierIconFreeSubscriptionPickerOpenButton'}/>
          {translationsStore.translate('freeSubscriptionPicker.usePortability')}
        </div>
        <Modal className={'FreeSubscriptionPickerModal'} visible={visible} onCancel={this.onCancel} footer={null} closable={false} destroyOnClose={true} width={900}>
          <div className="InstallerPickerAction" onClick={this.onCancel} style={{ position: 'absolute', top: 10, right: 10, zIndex: 1 }}>
            <CloseIcon style={{ width: 10, height: 10 }} />
          </div>
          <div className={'FreeSubscriptionPickerModalContent'}>
            <div className={'FreeSubscriptionPickerTitle'}>{translationsStore.translate('freeSubscriptionPicker.modal.title')}</div>
            <div className={'FreeSubscriptionPickerTableContainer'}>
              <Spin tip={commonStore.loadingMessage} spinning={subscriptionsStore.loading} size="large">
                <Table columns={columns} dataSource={dataSource} rowClassName="ClientRow"/>
              </Spin>
            </div>
            <div className={'FreeSubscriptionPickerFooterContainer'}>
              <AirButton
                light="true"
                size="large"
                onClick={this.onUseSubscription}
                label={translationsStore.translate('freeSubscriptionPicker.modal.useSubscription')}
                disabled={disableButton}
                bgcolor={!disableButton ? `var(--primary-color)` : `var(--grey)`}
              />
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ConnectionRequestsDashboard/NewConnectionRequest/FreeSubscriptionPicker/FreeSubscriptionPicker.js